import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";


import { getInitials } from "../utils/generatefilename";
import { infoorange, smallclock } from "./svg/iconsvg";
import { patientPhotoUrl } from "../config/practice";
dayjs.extend(customParseFormat);
const StatusCard = ({ item,onProfileClick ,activeTab,colors, onOpenBenefits}) => {
  console.log("ITEM:", item);
console.log("last_visit_time:", item?.last_visit_time);
const lastVisitTime = item?.last_visit_time;
const parsedTime = lastVisitTime
  ? dayjs(lastVisitTime, "HH:mm:ss")
  : null;

let buttoncolors=[
  {bg:"#FF6900",text:"#FFFFFF"},
  {bg:"rgba(80, 134, 154, 0.20)",text:"#2C5282"},
  {bg:"#50869A",text:"#FFFFFF"},
]
  console.log(item,'item in status card');
  return (
   <div
  className="
    flex flex-col gap-4
    rounded-[10px]
    
    bg-white
    h-auto
    px-4 py-3
    shadow-sm
  "
  style={{
    boxShadow:
      "inset 0 1px 0 #E5E7EB, 0 1px 3px rgba(0,0,0,0.08)",
  }}
>
<div className=" flex items-center justify-between">

  {/* Left */}
      <div className="flex flex-col items-start gap-2">
        {/* Avatar */}

        <div className="flex items-center gap-3">
    <div
  onClick={() => {
    if(item.ins_status === "A"||item.ins_status === "R"){
      return
    }
  onProfileClick(item)}}
  className="relative flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-sm font-semibold text-white overflow-hidden"
  style={{
    backgroundColor: colors?.[item?.ins_status] || "#E5E7EB"  /* unset = light grey, distinct from P amber */,
  }}
>
  <img
    src={patientPhotoUrl(item.patientid)}
    alt={`${item?.firstname} ${item?.lastname}`}
    className="absolute inset-0 h-full w-full object-cover"
    onLoad={(e) => {
      // hide initials when image loads
      e.target.nextSibling.style.display = "none";
    }}
    onError={(e) => {
      // hide broken image, keep initials
      e.target.style.display = "none";
    }}
  />

  <span className="relative z-10">
    {getInitials(item?.firstname, item?.lastname)}
  </span>
</div>


        {/* Info */}
        <div className="flex text-start flex-col">
          <span className="text-sm font-semibold text-[#1F2937]">
            {item.firstname} {item.lastname}
          </span>
          <span className="text-xs text-gray-500">
            {item.insurance_name||'-'}
          </span>

          {/* Status */}
         {item && (
  !(
    item.ins_config &&
    Object.prototype.hasOwnProperty.call(
      item.ins_config,
      "referencenumber"
    ) &&
    String(item.ins_config.referencenumber || "").trim() !== ""
  )&&(activeTab === "needBenefits")  ? (
    /* NO BENEFITS ASSIGNED */
    <div
  
      className="mt-1 cursor-pointer flex items-center gap-1 text-xs text-[#F54900]"
    >
      {infoorange}
      <p className="text-sm text-[#F54900]">
        No benefits assigned
      </p>
    </div>
  ) : (
    // <></>
    /* BENEFITS EXIST → SHOW STATUS */
    <p
      className={`mt-1 text-sm font-medium ${
        item.ins_status === "A"
          ? "text-green-600"
          : item.ins_status === "R"? "text-red-600":
         item.ins_status === "P"?  "text-[#F54900]"
          : "text-gray-500"
      }`}
    >
    
          <div
      onClick={() => {
        // if(  item.ins_status === "P"){
        //     onOpenBenefits(item)
        // }
      }}
      className="mt-1 cursor-pointer flex items-center gap-1 text-xs"
    >
      {  item.ins_status === "P"? infoorange:<></>}
      <p className="text-sm ">
     {item.ins_status === "A"
        ? "Approved"
        : item.ins_status === "R"
        ? "Rejected"
        : "Pending"}
      </p>
    </div>
    </p>
  )
)}

        </div>

      </div>

      </div>

{/* Right */}
<div className="flex flex-col gap-1 items-end text-xs text-gray-400">
  {/* Time */}
  <div>


    
  </div>
<span className="text-[#50869A] font-bold">
  {parsedTime?.isValid() ? parsedTime.format("h:mm A") : "--"}
</span>




  {/* Last Visit */}
  <span className="mt-1 flex items-center gap-1">
    {smallclock}
    <span>
      Last Visit:{" "}
      {dayjs(item?.last_visit_date).isValid()
        ? dayjs(item.last_visit_date).format("MMM D")
        : "--"}
    </span>
  </span>
   {activeTab === "needBenefits" && <div
    onClick={() => onOpenBenefits(item)}
    className="bg-[#1D2951] px-2 py-1 mt-2 text-white rounded-full cursor-pointer shadow-md"
  >
    Add Benefits
  </div>}
</div>

</div>
      
<div className="flex flex-col gap-2">
     {Array.isArray(item?.ins_config?.benefits) &&
  item.ins_config.benefits.length > 0 && (
    <div className="flex items-center gap-2">
      <span className="text-xs text-[#6A7282]">Covered:</span>

      <div className="flex flex-wrap gap-2">
     {item.ins_config.benefits.map((benefit, index) => {
  const color = buttoncolors[index % buttoncolors.length];

  return (
    <span
      key={index}
      className="px-3 py-1 text-xs rounded-full font-medium"
      style={{
        backgroundColor: color.bg,
        color: color.text,
      }}
    >
      {benefit}
    </span>
  );
})}

      </div>
    </div>
)}
{item?.ins_config?.updatedby &&
  item?.ins_config?.updatedon &&
  dayjs(item.ins_config.updatedon).isValid() && (
    <span className="mt-1 flex items-center gap-1 text-[11px] text-gray-400">
      {smallclock}
      <span>
        Last Updated:{" "}
        {dayjs(item.ins_config.updatedon).format("DD/MM/YYYY h:mm A")} by{" "}
        {item.ins_config.updatedby}
      </span>
    </span>
)}

</div>

    </div>
  );
};

export default StatusCard;
